module.exports = __webpack_public_path__ + "static/img/pic_setting_3.23beaa32.png";